import {Component, OnInit} from '@angular/core';
import {BottomSliderComponent} from "../component/bottom-slider/bottom-slider.component";
import {StoryListItemComponent} from "./story-list-item/story-list-item.component";
import {AccordionModule} from "primeng/accordion";
import {CheckboxChangeEvent, CheckboxModule} from "primeng/checkbox";
import {PerformanceSectionComponent} from "../component/performance-section/performance-section.component";
import {TemplateComponent} from "../template/template.component";
import {Pages} from "../../dto/Pages";
import {DataViewModule} from "primeng/dataview";
import {KeyValuePipe, NgForOf, NgIf} from "@angular/common";

@Component({
  selector: 'app-success-story-list-page',
  standalone: true,
    imports: [
        BottomSliderComponent,
        StoryListItemComponent,
        AccordionModule,
        CheckboxModule,
        PerformanceSectionComponent,
        DataViewModule,
        NgForOf,
        KeyValuePipe,
        NgIf
    ],
  templateUrl: './success-story-list-page.component.html',
  styleUrl: './success-story-list-page.component.css'
})
export class SuccessStoryListPageComponent extends TemplateComponent implements  OnInit{
    pages:Array<Pages> = new Array<Pages>();
    totalPages:number= 0;
    attributFilterList:Map<string,Set<string>> = new Map<string, Set<string>>();
    selectedFilter:Set<string>= new Set<string>();
    listSummery: string = "";
    defListCount:number=6;
    ngOnInit() {
        this.titleService.setTitle("Search as a service");
        document.body.scrollTop = 0;
        this.listSummery  = JSON.parse(this.global.getMainData()['list-pages']['data'])['success']['text'];
        setTimeout(()=>{
            this.loadAttribute();
        },0)

    }

    loadPageData(table) {
        this.global.progressBar = true;
        let filter:string="";
        for (let value of this.selectedFilter.values()) {
            filter+=("&filter="+value);
        }
        var observable = this.restBack.doGet("lnd/site/get_page_list?" +
            "page=" + (table != null ? table.first / this.defListCount: 0) +
            "&nrpp=" + (table != null && table.rows ? table.rows : this.defListCount)+
            "&type=SUCCESS_STORY" +
            filter +
            "" );

        observable.subscribe({
            next: (res: string) => {
                if (res["status"] == 200) {
                    this.pages = res["entity"];
                    this.totalPages= res["total"];

                }
                return res;
            },
            error: (e) => {
                this.messageService.clear();
                this.messageService.add({
                        severity: 'error',
                        summary: $localize`:@@Error:Error`,
                        detail: $localize`:@@Server Timout Det:Server Timout Det`
                    }
                );
            },
            complete: () => {
                this.global.progressBar = false;
                this.cdr.detectChanges();
            }
        });
    }
    loadAttribute() {
        this.global.progressBar = true;
        var observable = this.restBack.doGet("lnd/site/get_attribute?" +
            "&type=SUCCESS_STORY" +
            "" );
        observable.subscribe({
            next: (res: string) => {
                if (res["status"] == 200) {
                    this.attributFilterList = res["entity"];
                    // console.log(this.attributFilterList);

                }
                return res;
            },
            error: (e) => {
                this.messageService.clear();
                this.messageService.add({
                        severity: 'error',
                        summary: $localize`:@@Error:Error`,
                        detail: $localize`:@@Server Timout Det:Server Timout Det`
                    }
                );
            },
            complete: () => {
                this.global.progressBar = false;
                this.cdr.detectChanges();
            }
        });
    }

    filterByAttribute(event: CheckboxChangeEvent, filter: string) {
        if(event.checked) {
            this.selectedFilter.add(filter);
        }else {
            this.selectedFilter.delete(filter);
        }
        setTimeout(()=>{
            this.loadPageData(null);
        },0)


    }

    clickMoreList() {
        document.getElementById('page-list').scrollIntoView();
        document.body.scrollBy(0,-50);
    }

    protected readonly Object = Object;
}
